module.exports = __webpack_public_path__ + "bin/7411cd7f4970d7b0311c8f51786563fa.jpg";